tnDownloadEulaLink.$inject = ['apiBaseURl'];
export default function tnDownloadEulaLink(apiBaseURl) {
    return {
        link: function (scope) {
            scope.downloadUrl =
                apiBaseURl +
                '/api/1/orders/' +
                scope.order.id +
                '/download_eula';
        },
        scope: {
            order: '=',
        },
        template:
            '<a ng-href="{{downloadUrl}}?order_token={{order.order_token}}" ng-transclude></a>',
        transclude: true,
    };
}
